import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { GetControlModule } from "../ocas/get-control/get-control.module";
import { FileDetailsModule } from "../pipes/file-details/file-details.module";
import { DocumentViewerModule } from "../shared/document-viewer/document-viewer.module";
import { ProgressModule } from "../shared/progress/progress.module";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxLoadingModule } from "ngx-loading";
import { OcasAuditComponent } from "./ocas-audit.component";

const routes: Routes = [{ path: "ocas/audit/:id", component: OcasAuditComponent },];

@NgModule({
    declarations: [OcasAuditComponent],
    imports: [
      CommonModule,
       RouterModule.forChild(routes),
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      GetControlModule,
      FileDetailsModule,
      ProgressModule,
      DocumentViewerModule,
      PdfViewerModule,
      NgxLoadingModule,
    ],
    exports: [OcasAuditComponent],
  })
  export class OcasAuditModule {}
  